// libs
import React, { PureComponent, createRef } from 'react';
// components
import Menu from '@/components/Menu';
// widgets
import DropdownContent from './widgets/Content';
// helpers
import { transformOptions } from './helpers';
// dls
import DlsTextField from '@/widgets/DlsTextFeild/DlsTextField';
import { RightActionTypes, TextFieldTypes, } from '@swiggy-private/dls-web-core/dist/components/TextField/types';
const defaultProps = {
    disabledOptions: [],
};
class MultiSelectBox extends PureComponent {
    constructor() {
        super(...arguments);
        this.menuApiRef = createRef();
        this.state = this.getInitialState();
        this.onChange = (value) => {
            var _a;
            this.setState({ searchText: value });
            this.props.onInputTextChange(value);
            this.openMenu();
            (_a = this.menuApiRef.current) === null || _a === void 0 ? void 0 : _a.refresh();
        };
        this.closeMenu = () => {
            if (this.menuApiRef.current) {
                this.menuApiRef.current.close();
            }
        };
        this.openMenu = () => {
            if (this.menuApiRef.current && !this.menuApiRef.current.isOpen) {
                this.menuApiRef.current.open();
            }
        };
        this.handleFocus = (_) => {
            if (this.props.openOnFocus)
                this.openMenu();
        };
        this.updateSelectedOptions = (updatedOptions) => {
            var _a;
            this.setState({ internalOptions: updatedOptions });
            (_a = this.menuApiRef.current) === null || _a === void 0 ? void 0 : _a.refresh();
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.options !== this.props.options ||
            prevProps.options.length !== this.props.options.length) {
            const internalOptions = transformOptions({
                options: this.props.options,
                values: this.props.values,
                disabledValues: this.props.disabledOptions,
                identifier: this.props.identifier,
            });
            this.setState({ internalOptions });
        }
        if (prevProps.values !== this.props.values ||
            prevProps.values.length !== this.props.values.length) {
            const internalOptions = transformOptions({
                options: this.props.options,
                values: this.props.values,
                disabledValues: this.props.disabledOptions,
                identifier: this.props.identifier,
            });
            this.setState({ internalOptions });
        }
    }
    render() {
        const contentProps = {
            options: this.state.internalOptions,
            renderFunction: this.props.renderFunction,
            updateOptions: this.updateSelectedOptions,
            closeMenu: this.closeMenu,
            onChange: this.props.onChange,
            selectAllLabel: this.props.selectAllLabel,
            errorMessage: this.props.errorMessage,
            showLoader: this.props.showLoader,
            searchText: this.state.searchText,
            className: this.props.className,
        };
        return (React.createElement(Menu, { autoUpdatePosition: this.props.autoUpdatePosition, Content: DropdownContent, placement: "bottom-start", contentProps: contentProps, ref: this.menuApiRef },
            React.createElement(DlsTextField, { textFieldDetails: {
                    value: this.state.searchText,
                    isDisabled: this.props.disabled,
                    type: TextFieldTypes.TEXT,
                    name: 'multi-select-box-input',
                    label: this.props.placeholder || 'Search',
                    onChange: this.onChange,
                    onFocus: this.handleFocus,
                    attrs: { autoComplete: 'off' },
                    errorText: this.props.inputErrorText,
                }, rightActionDetails: [
                    {
                        type: RightActionTypes.CLEAR,
                    },
                ] })));
    }
    getInitialState() {
        return {
            internalOptions: transformOptions({
                options: this.props.options,
                values: this.props.values,
                disabledValues: this.props.disabledOptions,
                identifier: this.props.identifier,
            }),
            searchText: '',
        };
    }
}
MultiSelectBox.defaultProps = defaultProps;
export default MultiSelectBox;
